<div class="dashboard-wrapper" [class.edit-mode]="layoutEditMode">

  <!-- ============ DATE / TIME HEADER BANNER ============ -->
  <div class="date-banner">
    <div class="date-banner__left">
      <div class="date-banner__segment">
        <span class="date-banner__label">Month</span>
        <span class="date-banner__value" [innerHtml]="dateMonth"></span>
      </div>
      <div class="date-banner__divider"></div>
      <div class="date-banner__segment">
        <span class="date-banner__label">Date</span>
        <span class="date-banner__value" [innerHtml]="date"></span>
      </div>
      <div class="date-banner__divider"></div>
      <div class="date-banner__segment">
        <span class="date-banner__label">Year</span>
        <span class="date-banner__value" [innerHtml]="dateFullYear"></span>
      </div>
    </div>
    <div class="date-banner__right">
      <span class="date-banner__label">Current Time</span>
      <span class="date-banner__time">{{ time | date: 'hh:mm' }} | {{ampm}}</span>
    </div>
  </div>

  <!-- ============ TOP KPI CARDS ROW ============ -->
  <div class="kpi-row">

    <!-- Upcoming Meeting -->
    <div class="kpi-card kpi-card--clickable" *ngIf="dashboardModel?.meeting?.visible !== false" (click)="categoryRoute('/meetings/view')">
      <div class="kpi-card__header">
        <span class="kpi-card__icon kpi-card__icon--blue">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
        </span>
        <span class="kpi-card__badge kpi-card__badge--primary" style="margin-left: -50px;" *ngIf="dateMeet?.data.dateLabel">{{ dateMeet?.data?.dateLabel }}</span>
        <span class="kpi-card__badge" [ngClass]="'kpi-card__badge--' + dateMeet?.badge?.color">
          {{ dateMeet?.badge?.label }}
        </span>
      </div>
      <div class="kpi-card__label">Upcoming Meeting</div>
      <div class="kpi-card__title">{{ meetingModel?.subject || 'No Meeting' }}</div>
      <div class="kpi-card__subtitle">{{meetingModel?.startTime}} - {{meetingModel?.endTime}}</div>
    </div>

    <!-- Upcoming Appointment -->
    <div class="kpi-card kpi-card--clickable" *ngIf="dashboardModel?.upcoming_appointment?.visible !== false && product !== 'corporate'" (click)="categoryRoute('/appointments')">
      <div class="kpi-card__header">
        <span class="kpi-card__icon kpi-card__icon--purple">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
        </span>
        <span class="kpi-card__badge kpi-card__badge--purple" style="margin-left: -50px;" *ngIf="appointmentModel?.date">{{ appointmentModel?.date}}</span>
        <span class="kpi-card__badge" [ngClass]="'kpi-card__badge--' + dateLabel?.badge?.color">
          {{ dateLabel?.badge?.label }}
        </span>
      </div>
      <div class="kpi-card__label">Upcoming Appointment</div>
      <div class="kpi-card__title">{{ appointmentModel?.client_name || 'No Appointment' }}</div>
      <div class="kpi-card__subtitle">{{ appointmentModel?.startTime }} - {{ appointmentModel?.endTime}}</div>
    </div>

    <!-- Total Billable Hours -->
    <ng-container *ngIf="dashboardModel?.hours?.visible !== false && userRole !== 'AAM' && product !== 'corporate'">
    <div class="kpi-card kpi-card--clickable" (click)="categoryRouteMonthView('/timesheets/aggregate-members','month', hoursModel.lastTimesheetMonth)">
      <div class="kpi-card__header">
        <span class="kpi-card__icon kpi-card__icon--teal">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
        </span>
        <!-- <span class="kpi-card__badge kpi-card__badge--success">+{{hoursModel.billablePercentage}}%</span> -->
        <span class="kpi-card__badge" [ngClass]="'kpi-card__badge--' + hoursModel?.badge?.color">
          {{ hoursModel?.badge?.label }}
        </span>
      </div>
      <div class="kpi-card__label">Total Billable Hours</div>
      <div class="kpi-card__title kpi-card__title--large">{{hoursModel?.data?.billableHours}}</div>
      <div class="kpi-card__subtitle">{{hoursModel?.data?.dateRangeLabel}}</div>
    </div>
    </ng-container>

    <!-- Approximate Revenue -->
    <ng-container *ngIf="dashboardModel?.approximate_revenue?.visible !== false && product !== 'corporate'">
    <div class="kpi-card">
      <div class="kpi-card__header">
        <span class="kpi-card__icon kpi-card__icon--green">
          <span class="kpi-card__icon kpi-card__icon--green">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M6 3h9a3 3 0 0 1 3 3v15l-3-2-3 2-3-2-3 2V6a3 3 0 0 1 3-3z"/>
              <line x1="9" y1="8" x2="15" y2="8"/>
              <line x1="9" y1="12" x2="13" y2="12"/>
            </svg>
          </span>
        </span>
        <!-- <span class="kpi-card__badge kpi-card__badge--success">{{approximateRevenue.badge.label}}</span> -->
        <span class="kpi-card__badge" [ngClass]="'kpi-card__badge--' + approximateRevenue?.badge?.color">
          {{ approximateRevenue?.badge?.label }}
        </span>
      </div>
      <div class="kpi-card__label">Approximate Revenue</div>
      <div class="kpi-card__title kpi-card__title--large">
        {{ approximateRevenue?.data?.amount 
           | currency: approximateRevenue?.data?.currency?.symbol }}
       </div>
      <div class="kpi-card__subtitle">{{approximateRevenue?.data?.dateRangeLabel}}</div>
    </div>
    </ng-container>

  </div>

  <!-- ============ CHARTS ROW ============ -->
  <div class="charts-row">

    <!-- Appointment Trend (Bar Chart) -->
    <div class="chart-card chart-card--wide" *ngIf="dashboardModel?.appointmentTrend?.visible !== false && product !== 'corporate'">
      <div class="chart-card__header">
        <div>
          <div class="chart-card__title">Appointment Trend</div>
          <div class="chart-card__subtitle">Weekly overview</div>
        </div>
      </div>
      <div class="chart-card__body">
        <canvas id="appointmentChart" height="180"></canvas>
        <div class="chart-legend">
          <span class="legend-dot legend-dot--blue"></span><span>Upcoming</span>
          <span class="legend-dot legend-dot--green"></span><span>Completed</span>
          <span class="legend-dot legend-dot--red"></span><span>Cancelled</span>
        </div>
      </div>
    </div>

    <!-- Revenue Trend (Area Chart) -->
    <div class="chart-card chart-card--wide" *ngIf="dashboardModel?.revenueTrend?.visible !== false && product !== 'corporate'">
      <div class="chart-card__header">
        <div>
          <div class="chart-card__title">Revenue Trend</div>
          <div class="chart-card__subtitle">Based on appointments</div>
        </div>
        <select class="chart-filter" id="revenuePeriod" (change)="onRevenuePeriodChange($event)">
          <option value="7">7 Days</option>
          <option value="30">30 Days</option>
          <option value="90">90 Days</option>
        </select>
      </div>
      <div class="chart-card__body">
        <canvas id="revenueChart" height="180"></canvas>
      </div>
    </div>

    <!-- Data Storage (Donut Chart) -->
    <div class="chart-card chart-card--narrow" *ngIf="dashboardModel?.storage?.visible !== false && userRole !== 'TM'" style="cursor: initial;">
      <div class="chart-card__title">Data Storage</div>
      <div class="storage-info">
        <div class="storage-info__row">
          <span class="storage-info__label">Total Storage</span>
          <span class="storage-info__value--used">Used</span>
        </div>
        <div class="storage-info__row storage-info__row--values">
          <span class="storage-info__total">
            <ng-container>{{storageModel?.data?.totalGB}} GB</ng-container>
          </span>
          <span class="storage-info__used">{{storageModel?.data?.usedGB}} GB</span>
        </div>
      </div>
      <div class="storage-donut-container">
        <canvas id="storageChart" width="120" height="120"></canvas>
        <div class="storage-donut-center">
          <div class="storage-donut-center__label">Available</div>
          <div class="storage-donut-center__value">{{storageModel?.data?.availableGB}} GB</div>
          <span class="storage-meta">{{storageModel?.data?.usedGB}} GB used · {{storageModel?.data?.availableGB}} GB available</span>
        </div>
      </div>
    </div>

  </div>

  <!-- ============ BOTTOM CARDS ROW ============ -->
  <div class="bottom-row">

    <!-- Messages Card -->
    <div class="bottom-card bottom-card--clickable" *ngIf="dashboardModel?.messages?.visible === true">
      <div class="bottom-card__header">
        <span class="bottom-card__title">Messages</span>
        <span class="bottom-card__badge">
          {{ (unreadcountclient || 0) + (catsolo !== 'solo' ? (unreadcountteam || 0) : 0) }}
        </span>
      </div>
      <div class="bottom-card__messages">
        <div class="msg-item" *ngIf="userRole !== 'AAM'" (click)="categoryRoute('/messages/clients')">
          <div class="msg-item__icon msg-item__icon--client">
            <svg viewBox="0 0 24 24">
              <circle cx="12" cy="8" r="3.5"/>
              <path d="M4 19c0-3.5 3.5-6 8-6s8 2.5 8 6"/>
            </svg>
          </div>
          <div class="msg-item__count">{{unreadcountclient}}</div>
          <div class="msg-item__label">
            <ng-container *ngIf="product != 'corporate'">Client Messages</ng-container>
            <ng-container *ngIf="product == 'corporate'">External Counsel Messages</ng-container>
          </div>
        </div>
        <div class="msg-divider" *ngIf="catsolo !== 'solo' && userRole !== 'AAM'"></div>
        <div class="msg-item" *ngIf="catsolo !== 'solo'" (click)="categoryRoute('/messages/teams')">
          <div class="msg-item__icon msg-item__icon--team">
            <svg viewBox="0 0 24 24">
              <circle cx="9" cy="8" r="3"/>
              <circle cx="17" cy="10" r="2.5"/>
              <path d="M3 18c0-3 3-5 6-5s6 2 6 5"/>
              <path d="M14 18c0-2 2-3.5 4-3.5s4 1.5 4 3.5"/>
            </svg>
          </div>
          <div class="msg-item__count">{{unreadcountteam}}</div>
          <div class="msg-item__label">Team Messages</div>
        </div>
      </div>
    </div>

    <!-- Matter Status Card -->
    <div class="bottom-card" *ngIf="dashboardModel?.matter?.visible !== false && userRole !== 'AAM'" style="cursor: pointer;" (click)="categoryRoute('/matter/matter/legalmatter/view')">
      <div class="bottom-card__header">
        <span class="bottom-card__title">Matter Status</span>
        <span class="bottom-card__badge">{{(matterModel?.data?.grandTotal || 0)}}</span>
      </div>
      <div class="matter-chart-container" style="cursor: pointer;" (click)="$event.stopPropagation()">
        <canvas id="matterChart" height="140"></canvas>
      </div>
      <div class="matter-legend">
        <span class="legend-dot legend-dot--blue"></span>
        <span class="matter-count" style="cursor: pointer;" (click)="$event.stopPropagation(); categoryRoute('/matter/matter/legalmatter/view')">{{ matterModel?.data?.activeTotalCount || 0 }} Active</span>
        <span class="legend-dot legend-dot--purple" style="margin-left: 12px;"></span>
        <span class="matter-count" style="cursor: pointer;" (click)="$event.stopPropagation(); categoryRoute('/matter/matter/generalmatter/view')">{{ matterModel?.data?.closedTotalCount || 0 }} Closed</span>
      </div>
    </div>

    <!-- Corporate Matters -->
    <!-- <div class="bottom-card" *ngIf="product === 'corporate'">
      <div class="bottom-card__header">
        <span class="bottom-card__title">Matter Status</span>
        <span class="bottom-card__badge">{{(externalmatterModel?.external?.total || 0) + (externalmatterModel?.internal?.total || 0)}}</span>
      </div>
      <div class="matter-chart-container">
        <canvas id="corpMatterChart" height="90"></canvas>
      </div>
      <div class="matter-legend">
        <span class="legend-dot legend-dot--blue"></span>
        <span class="matter-count">{{ externalmatterModel?.external?.total || 0 }} External</span>
        <span class="legend-dot legend-dot--purple" style="margin-left: 12px;"></span>
        <span class="matter-count">{{ externalmatterModel?.internal?.total || 0 }} Internal</span>
      </div>
    </div> -->

    <!-- Notifications Card -->
    <div class="bottom-card bottom-card--clickable" *ngIf="dashboardModel?.notification?.visible !== false" (click)="categoryRoute('/notifications')">
      <div class="bottom-card__header">
        <span class="bottom-card__title">Notifications</span>
        <span class="bottom-card__badge bottom-card__badge">
          {{ notifyModel?.data?.unreadCount || 0 }}
        </span>
      </div>
    
      <div class="notify-list">
        <div class="notify-item" *ngFor="let notify of notifyModel?.data?.notifications">
    
          <div class="notify-item__text">
            {{ notify?.message }}
          </div>
    
          <div class="notify-item__date">
            {{ notify?.date }} | {{ notify?.time + 'Z' | date:'hh:mm a':'Asia/Kolkata' }}
          </div>
    
        </div>
        <div class="notify-empty" *ngIf="!notifyModel?.data?.notifications?.length">
          No new notifications
        </div>
    
      </div>
    </div>

    <!-- Subscription Card -->
    <div class="bottom-card" *ngIf="dashboardModel?.subscription?.visible !== false && (userRole === 'AAM' || userRole === 'SU') && product !== 'corporate'" style="cursor: pointer;"
    (click)="categoryRoute('/settings')">
      <div class="bottom-card__header">
        <span class="bottom-card__title">Subscription</span>
        <!-- <span class="bottom-card__badge bottom-card__badge--active">Active</span> -->

           <span class="kpi-card__badge" [ngClass]="'kpi-card__badge--' + subscriptionModel?.data?.statusBadge?.color">
          {{ subscriptionModel?.data?.statusBadge?.label }}
        </span>

      </div>
      <div class="sub-content">
        <div class="sub-plan-box">
          <div class="sub-plan-label">Product Subscription</div>
          <div class="sub-plan-name">{{ subscriptionModel?.data?.planLabel }}</div>
        </div>
        <div class="sub-details">
          <div class="sub-detail-row">
            <span class="sub-detail-label" *ngIf="!subscriptionModel?.data?.canPayNow">Valid Until</span>
            <span class="sub-detail-label" *ngIf="subscriptionModel?.data?.canPayNow">Expired On</span>
            <span class="sub-detail-value" [innerHtml]="subscriptionModel?.data?.validTill || 'N/A'"></span>
          </div>
        </div>
                  
        <button class="sub-pay-btn" *ngIf="subscriptionModel?.data?.canPayNow" (click)="onButtonClick(subscriptionModel)">Pay Now</button>
      </div>
    </div>

    <!-- KPI Cards that don't fit in main layout -->

    <!-- Billable Hours (alternate) - hidden as it's in top row -->
    <!-- Average Billing Rate -->
    <!-- <div class="bottom-card bottom-card--clickable" *ngIf="kpiCards.includes('avgBillingRate') && product !== 'corporate'">
      <div class="bottom-card__header">
        <span class="bottom-card__title">Avg. Billing Rate</span>
      </div>
      <div class="bottom-stat">
        <div class="bottom-stat__value">{{hoursModel.averageBillingRate | currency:hoursModel?.currency?.symbol}}</div>
        <div class="bottom-stat__label">Per Hour</div>
      </div>
    </div> -->

    <!-- Relationships -->
    <div class="bottom-card bottom-card--clickable" *ngIf="kpiCards.includes('relationships')" (click)="categoryRoute('/relationship/view/individuals')">
      <div class="bottom-card__header">
        <span class="bottom-card__title">Relationships</span>
      </div>
      <div class="rel-stats">
        <div class="rel-stat">
          <span class="rel-stat__value">{{relationshipModel?.accepted}}</span>
          <span class="rel-stat__label">Accepted</span>
        </div>
        <div class="rel-stat__divider"></div>
        <div class="rel-stat">
          <span class="rel-stat__value">{{relationshipModel?.pending}}</span>
          <span class="rel-stat__label">Pending</span>
        </div>
      </div>
    </div>

    <!-- New Hires -->
    <div class="bottom-card bottom-card--clickable" *ngIf="dashboardModel?.hiring?.visible !== false && catsolo !== 'solo' && product !== 'corporate'">
      <div class="bottom-card__header">
        <span class="bottom-card__title">New Hires</span>
        <span class="bottom-card__badge" *ngIf="dashboardModel?.hiring?.badge?.label">
          {{ dashboardModel?.hiring?.badge?.label }}
        </span>
      </div>
      <div class="hire-pills">
        <ng-container *ngFor="let group of hiringModel; let i = index">
          <div class="hire-pill" [class]="'hire-pill--' + (i % 2 === 0 ? 'purple' : 'pink')"
               (click)="categoryRouteGroupName('/groups/view-group', group.type)">
            <span class="hire-pill__count">{{ group?.count }}</span>
            <span class="hire-pill__label">{{ group?.type }}</span>
          </div>
        </ng-container>
        <div class="notify-empty" *ngIf="!hiringModel?.length">
          No groups available
        </div>
      </div>
    </div>

    <!-- New Clients / Relationships -->
    <div class="bottom-card bottom-card--clickable" *ngIf="kpiCards.includes('relationships')" (click)="categoryRoute('/relationship/view/individuals')">
      <div class="bottom-card__header">
        <span class="bottom-card__title">New Clients</span>
      </div>
      <div class="rel-stats">
        <div class="rel-stat">
          <span class="rel-stat__value">{{clientModel[0]?.count}}</span>
          <span class="rel-stat__label">{{clientModel[0]?.type}}</span>
        </div>
        <div class="rel-stat__divider" *ngIf="clientModel[1]"></div>
        <div class="rel-stat" *ngIf="clientModel[1]">
          <span class="rel-stat__value">{{clientModel[1]?.count}}</span>
          <span class="rel-stat__label">{{clientModel[1]?.type}}</span>
        </div>
      </div>
    </div>

    <!-- Groups & TMs (corporate/connect/content) -->
    <ng-container *ngIf="product === 'content' || product === 'connect'">
    <div class="bottom-card bottom-card--clickable" (click)="handleGroupNavigation()" [class.disabled-card]="userRole === 'GH'">
      <div class="bottom-card__header">
        <span class="bottom-card__title">
          <ng-container>Total Groups</ng-container>
          <!-- <ng-container *ngIf="product !== 'corporate'">Total Groups</ng-container>
          <ng-container *ngIf="product === 'corporate'">Total Departments</ng-container> -->
        </span>
        <span class="bottom-card__value">{{groupsandtmsModel?.totalGroups}}</span>
      </div>
    </div>
    <div class="bottom-card bottom-card--clickable" (click)="categoryRoute('/groups/view-member')" *ngIf="userRole !== 'TM'">
      <div class="bottom-card__header">
        <span class="bottom-card__title">Team Members</span>
        <span class="bottom-card__value">{{groupsandtmsModel?.totalTms}}</span>
      </div>
    </div>
    </ng-container>

    <!-- External Counsels (corporate) -->
    <div class="bottom-card bottom-card--clickable" *ngIf="kpiCards.includes('newCounsels')" (click)="categoryRoute('/relationship/view/corporate')">
      <div class="bottom-card__header">
        <span class="bottom-card__title">New External Counsels</span>
      </div>
      <div class="rel-stats">
        <div class="rel-stat">
          <span class="rel-stat__value">{{externalModel[0]?.count}}</span>
          <span class="rel-stat__label">{{externalModel[0]?.type}}</span>
        </div>
      </div>
    </div>

  </div>

</div>

<ngx-spinner size="medium" type="ball-clip-rotate"></ngx-spinner>